module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter22"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "href": "#/003toc#ch22"
    }
  }, [_vm._v("Vegetarian Confetti Split Pea Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Split pea soup is a favorite at my house, but it usually has a base of smoked sausage or a ham bone to give it flavor and punch. When I decided to try a vegetarian version, I added yellow split peas and red lentils to give the soup beautiful color and flavor.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 large onion, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 medium carrots, diced")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 stalks celery, diced")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 teaspoons dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 bay leaf")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 cups dried green split peas")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 cup dried yellow split peas")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("½ cup dried red lentils")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("8 cups vegetable broth")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("heat the oil in a skillet over medium-high heat. Add the onion, carrots, celery, thyme, and bay leaf and sauté until the vegetables begin to soften, 4 to 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("transfer the contents of the skillet to the insert of a 5- to 7-quart slow cooker and add the split peas, lentils, and broth, and stir to combine.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("cover the slow cooker and cook on high for 4 hours or on low for 8 hours; check the soup at 3 or 7 hours to make sure that it isn’t sticking to the pot. If it appears too thick, add more broth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("season with salt and pepper before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("serves 8")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5babdb98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/028-chapter22.vue
// module id = 138
// module chunks = 0